import api from 'api/apiInstance';

import { clientCaseSuitabilityLettersGenerateApi } from './generate';
import { clientCaseSuitabilityLettersLastApi } from './last';
import { clientCaseSuitabilityLetterApi } from './suitabilityLetter';
import type { SuitabilityLettersResponse } from './types';

type ClientCaseSuitabilityLetterApi = ReturnType<typeof clientCaseSuitabilityLetterApi>;

export function clientCaseSuitabilityLettersApi(path: string) {
  function suitabilityLetter(letterId: number | string): ClientCaseSuitabilityLetterApi {
    return clientCaseSuitabilityLetterApi(`${path}/${letterId}`);
  }

  return {
    path,
    GET: () =>
      api.get<SuitabilityLettersResponse>(path, {
        // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
        skipRedirect: true,
      }),
    last: () => clientCaseSuitabilityLettersLastApi(`${path}/last`),
    generate: () => clientCaseSuitabilityLettersGenerateApi(`${path}/generate`),
    suitabilityLetter,
  };
}
